import React, { useState, useEffect, createContext } from 'react';

export const MobileContext = createContext();

export const MobileProvider = ({ children }) => {
  const [isMobile, setIsMobile] = useState(null);

  useEffect(() => {
    const testExp = new RegExp('mobi', 'i');
    setIsMobile(testExp.test(navigator.userAgent));
  }, []);

  const mobileStyle = style => (isMobile ? style : null);

  const desktopStyle = style => (!isMobile ? style : null);

  return (
    <MobileContext.Provider
      value={{
        isMobile,
        desktopStyle,
        mobileStyle,
      }}
    >
      {children}
    </MobileContext.Provider>
  );
};

export const withMobile = Component => props => (
  <MobileContext.Consumer>
    {context => <Component {...props} mobileContext={context} />}
  </MobileContext.Consumer>
);
